import { gql } from "apollo-angular";

export const CA = gql`
  fragment CA on CareerAssessment {
    title
    backgroundColor {
      color
    }
    header
    hTag
    introCopy
    button1Label
    button2Label
  }`;
